import React from 'react';
import { Phone, FileText } from 'lucide-react';
export function MobileBottomBar() {
  const scrollToForm = () => {
    document.getElementById('quote-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] pb-safe" data-id="element-235">
      <div className="flex items-center p-3 gap-3" data-id="element-236">
        <a href="tel:+17543251100" className="flex-1 flex items-center justify-center gap-2 bg-brand-navy text-white font-bold py-3 px-4 rounded-lg active:bg-brand-navy-light transition-colors" data-id="element-237">
          <Phone className="w-5 h-5" data-id="element-238" />
          Call Now
        </a>
        <button onClick={scrollToForm} className="flex-1 flex items-center justify-center gap-2 bg-brand-red text-white font-bold py-3 px-4 rounded-lg active:bg-brand-red-hover transition-colors" data-id="element-239">
          <FileText className="w-5 h-5" data-id="element-240" />
          Free Quote
        </button>
      </div>
    </div>;
}